import { combineReducers } from 'redux';

import feedUiReducer from './feedUiReducer';
import feedDataReducer from './feedDataReducer';

export default combineReducers({
  ui: feedUiReducer,
  data: feedDataReducer,
});
